<template>
    <div class="h-full">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'BlankLayout'
}
</script>